const buttonClasses = 'border-2 border-neutrals-200 text-neutrals-500';

const buttonHoverClasses =
  'hover:border-neutrals-700 hover:bg-neutrals-700 hover:text-white [&:hover_svg]:fill-white';

const buttonIconClasses = 'fill-neutrals-500';

const buttonNeutralOutlinedClasses = {
  buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses],
  buttonIconClasses,
};

export default buttonNeutralOutlinedClasses;
